import { IModuleMetaData, Module } from "./module";

export class ModuleFactory {
	public static create(data:any, metadata?:IModuleMetaData):Module {
		return new Module(data, metadata);
	}
}